/** @format */

import { useState } from "react";
import Lottie from "lottie-react";
import animationData from "./Loading.json";
import ArrowRight from "../SvgIcons/ArrowRight";
import sentAnimationData from "./Sent.json";
const MailchimpSubscribe = () => {
  const [email, setEmail] = useState("");
  const [message, setMessage] = useState(null);
  const [isError, setIsError] = useState(false);
  const [loading, setLoading] = useState(false);
  const [sent, setSent] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    const url =
      "https://getpaths.us20.list-manage.com/subscribe/post?u=b2e273256553975923f8fac51&id=46cdf8a2b0&f_id=00d27deef0";
    const formData = new FormData();
    formData.append("EMAIL", email);

    try {
      await fetch(url, {
        method: "POST",
        body: formData,
        mode: "no-cors",
      });
      setMessage("Subscription successful!");
      setIsError(false);
      setEmail("");
      setSent(true);
      setTimeout(() => setSent(false), 3000);
    } catch (error) {
      setMessage("Subscription failed. Please try again.");
      setIsError(true);
    } finally {
      setLoading(false);
    }
  };

  const defaultOptions = {
    loop: true,
    autoplay: true,
    animationData: animationData,
    rendererSettings: {
      preserveAspectRatio: "xMidYMid slice",
    },
  };

  return (
    <form onSubmit={handleSubmit} className='input-group'>
      <input
        type='email'
        id='email'
        name='EMAIL'
        value={email}
        onChange={(e) => setEmail(e.target.value)}
        required
        className='input'
        placeholder='Enter your email...'
      />
      {message && (
        <p className={`text-sm ${isError ? "text-red-500" : "text-green-500"}`}>
          {message}
        </p>
      )}
      <button type='submit' disabled={loading || sent}>
        {loading ? (
          <Lottie animationData={animationData} loop height={24} width={24} />
        ) : sent ? (
          <Lottie
            animationData={sentAnimationData}
            loop
            height={24}
            width={24}
          />
        ) : (
          <ArrowRight />
        )}
      </button>
    </form>
  );
};

export default MailchimpSubscribe;
